'use strict';

angular.module('riskModule')

.controller('DepartmentalRisksExportModalController', ['$scope', 'grcGovernanceProcessService', function ($scope, grcGovernanceProcessService) {

    $scope.exportCtxt  = {};
    $scope.assessorUser     = null;
    $scope.canExportToReport = false;

    $scope.selectAssessor = function (person) {
        $scope.assessorUser = person;
        $scope.assessorID   = person.ItemPersonID;
        isReadyToExport();
    };

    function isReadyToExport() {
        $scope.canExportToReport = $scope.assessorUser && $scope.exportCtxt.currentProcess && $scope.exportCtxt.previousProcess;
    }

    grcGovernanceProcessService.getRiskSelfAssessments()
        .then(function (govProcesses) {
            $scope.govProcesses = govProcesses;

            $scope.exportCtxt.currentProcess = $scope.govProcesses[0];
            $scope.exportCtxt.previousProcess = $scope.govProcesses[1];
            isReadyToExport();
        });
}]);